// get path, query etc. from config file
import configData from '../../config'

import * as searchGetters from './store/searchStore-getters'
import * as filtersGetters from './store/filters-getters'
import * as dateFiltersGetters from './store/date-filters-getters'
// method to format date
import formatDate from './../../scripts/reusable/format-date'
// convert date to iso format
import convertToIso from './../../scripts/modules/local-iso-string'

// paths and setting in config file
const dataSolr = configData().solr

// facets fields set in config file
const facets = dataSolr.filters

const getPath = () => {
  let facetsPath = 'facet=' + facets.facet_on + '&facet.sort=' + facets.facet_sort_count +
                    // start/end date
                   '&stats=on&stats.field=date_start&stats.field=date_end'

  // generate query with available facet fields
  facets.facet_fileds.forEach(function(value) {
                   // facet field value and ex
    facetsPath +=  '&facet.field={!ex=' + value + '}' + value +
                   // facet limit
                   '&f.' + value + '.facet.limit=' + facets.facet_limit +
                   // facet mincount
                   '&f.' + value + '.facet.mincount=' + facets.facet_mincount
  });

  // returns path with facet fields, search query and facets query
  return dataSolr.paths.API + dataSolr.query.searchPre +
         facetsPath +
         getFiltersQuery() + getDateRangeQuery() + getSearchQuery() +
         dataSolr.query.searchPost
}

const getDateRangeQuery = () => {
  // current chosen date range
  let dateFrom = dateFiltersGetters.getDateFrom()
  let dateTo = dateFiltersGetters.getDateTo()
  let dateStart = dateFiltersGetters.getDateStart()
  let dateEnd = dateFiltersGetters.getDateEnd()
  let dateGap = dateFiltersGetters.getDateGap()
  let dateRangeQuery = ''

  // when chosen date is not empty
  if (dateFrom != '' && dateTo != '') {
    if (!(dateFrom == dateStart && dateTo == dateEnd)) {
      // when date is not equal to default new fq is created
      dateFrom = new Date(dateFrom)
      dateTo = new Date(dateTo)

      if(dateFrom.getTime() === dateTo.getTime()) {
        dateFrom.setHours(0,0,0,0)
        dateTo.setHours(23,59,59,999)
      }

      dateRangeQuery += '&facet.range=' + facets.facet_range +
      // to get correct facet end and start
      '&f.date.facet.range.hardend=true' +
      // date from
      '&f.date.facet.range.start=' + convertToIso(dateFrom) +
      // date to
      '&f.date.facet.range.end=' + convertToIso(dateTo) +
      // date range gap
      '&f.date.facet.range.gap=%2B' + dateGap + 'DAYS' +
      // facet
      '&fq={!tag=date}date:[' + formatDate(dateFrom) +
      ' TO ' + formatDate(dateTo) + ']'
    } else {
      // when date is equal te default new fq is not created (used when data is preloaded)
      dateStart = new Date(dateStart)
      dateEnd = new Date(dateEnd)

      if(dateStart.getTime() === dateEnd.getTime()) {
        dateStart.setHours(0,0,0,0)
        dateEnd.setHours(23,59,59,999)
      }

      dateRangeQuery += '&facet.range=' + facets.facet_range +
      // to get correct facet end and start
      '&f.date.facet.range.hardend=true' +
      // date from
      '&f.date.facet.range.start=' + convertToIso(dateStart) +
      // date to
      '&f.date.facet.range.end=' + convertToIso(dateEnd) +
      // date range gap
      '&f.date.facet.range.gap=%2B' + dateGap + 'DAYS'
    }
  }

  return dateRangeQuery
}

const getFiltersQuery = () => {
  // current chosen filters
  let filterParams = filtersGetters.getFilterParams()
  let filtersQuery = ''

  // loop through all filter types that were chosen
  filterParams.forEach(function(value) {
    // query for one filter type
    let filterQuery = '&fq={!tag=' + value.name + '}'

    function addElem(element, index, array) {
      if (index > 0) {
        filterQuery += ' OR ' + value.name + ': \"' + element + '\"'
      } else {
        filterQuery += value.name + ': \"' + element + '\"'
      }
    }
    // adds subfilters to query
    value.filters.forEach(addElem)

    // add filter with subfilters to query
    filtersQuery += filterQuery
  })

  return filtersQuery
}

const getSearchQuery = () => {
  // current search params filters
  let searchParams = searchGetters.searchParams()
  let searchQuery = '&q='

  let key = searchParams.key
  let param = searchParams.param
  let start = searchParams.start
  let rows = searchParams.rows
  let sorting = searchParams.sorting

  //key (+ params)
  if (param) {
    searchQuery += param + ":" + '(' + key + ')'
  } else {
    searchQuery += key
  }

  // rows
  searchQuery += '&rows=' + rows

  // sorting
  if (sorting) {
    searchQuery += '&sort=' + sorting
  }

  // start page
  if (start != 0) {
    searchQuery += '&start=' + start
  }

  return searchQuery
}

export default getPath



// WEBPACK FOOTER //
// ./src/scripts/modules/solr-helper.js